import { PackingTaskDetailPage } from "@/features/packing-task/pages/PackingTaskDetailPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/packing-task/$id/detail")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["packing_task.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: PackingTaskDetailPage,
});
